import React from 'react';
import { Redirect, Route, useRouteMatch } from 'react-router-dom';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import SelectCompanyFirstComponent from '../../components/SelectCompanyFirstComponent';
import { getSelectedCompany } from '../../store/selectors';
import Locations from './Locations';

const renderContent = (selectedCompany, match) => (
  !selectedCompany ? <SelectCompanyFirstComponent /> : (
    <>
      <Redirect
        exact
        from={`${match.url}`}
        to={`${match.url}/defined`}
      />
      <Route
        exact
        path={`${match.url}/defined`}
        component={Locations}
      />
    </>
  )
);

export default () => {
  const match = useRouteMatch();
  const { t } = useTranslation();
  const selectedCompany = useSelector(getSelectedCompany);

  return (
    <>
      <BreadcrumbsItem to="/">
        {t('BREADCRUMB.LOCATIONS')}
      </BreadcrumbsItem>
      <BreadcrumbsItem to="/locations/defined">
        {t('BREADCRUMB.DEFINED_LOCATIONS')}
      </BreadcrumbsItem>
      {renderContent(selectedCompany, match)}
    </>
  );
};
